<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('fe_invoice_payments.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openFeInvoicePaymentForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetFeInvoicePayments(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="fe_invoice_payments" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openFeInvoicePaymentForm(props.item)">
                                <td>{{ props.item.payment_id }}</td>
                                <td>{{ props.item.invoice_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.amount }}</td>
                                <td>{{ props.item.payment_term }}</td>
                                <td>{{ props.item.payment_date }}</td>
                                <td>{{ props.item.due_date }}</td>
                                <td>{{ props.item.account_name }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="fe_invoice_payments"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="fe_invoice_payment_dialog">
                <v-card>
                    <v-form ref="form_fe_invoice_payment">
                        <v-card-title>
                            <span class="headline">{{
                                fe_invoice_payment.payment_id ? $t("lang.edit_fe_invoice_payment") : $t("lang.add_fe_invoice_payment")
                            }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeFeInvoicePaymentDialog"
                                :dialog-status="fe_invoice_payment_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="fe_invoice_payment.invoice_id"
                                            :label="$t('lang.invoice_id')"
                                            :items="fe_invoices"
                                            item-value="invoice_id"
                                            item-text="invoice_id"
                                            :rules="ifValid('fe_invoice_payments.invoice_id')"
                                            @change="setupFeInvoicePaymentAmount(fe_invoice_payment.invoice_id)"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="fe_invoice_payment.amount"
                                            :label="$t('lang.amount')"
                                            :counter="showCounter(fe_invoice_payment.amount, 'fe_invoice_payments.amount')"
                                            :rules="ifValid('fe_invoice_payments.amount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="fe_invoice_payment.payment_term_id"
                                            :label="$t('lang.payment_term_id')"
                                            :items="payment_terms"
                                            item-value="payment_term_id"
                                            item-text="description"
                                            :rules="ifValid('fe_invoice_payments.payment_term_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="fe_invoice_payment.payment_date"
                                            :label="$t('lang.payment_date')"
                                            :rules="ifValid('fe_invoice_payments.payment_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="fe_invoice_payment.due_date"
                                            :label="$t('lang.due_date')"
                                            :rules="ifValid('fe_invoice_payments.due_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <!--<v-flex xs12>
                                        <bc-autocomplete
                                            v-model="fe_invoice_payment.currency_id"
                                            :label="$t('lang.currency_id')"
                                            :items="currencies"
                                            item-value="currency_id"
                                            item-text="name"
                                            :rules="ifValid('fe_invoice_payments.currency_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="fe_invoice_payment.exchange_rate"
                                            :label="$t('lang.exchange_rate')"
                                            :counter="showCounter(fe_invoice_payment.exchange_rate, 'fe_invoice_payments.exchange_rate')"
                                            :rules="ifValid('fe_invoice_payments.exchange_rate')"
                                        ></v-text-field>
                                    </v-flex>-->
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="fe_invoice_payment.account_id"
                                            :label="$t('lang.account_id')"
                                            :items="bank_accounts"
                                            item-value="account_id"
                                            item-text="account_name"
                                            :rules="ifValid('fe_invoice_payments.account_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="fe_invoice_payment.notes"
                                            :label="$t('lang.notes')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('fe_invoice_payments.notes')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="fe_invoice_payment.payment_id" color="error" @mouseup.left="$refs.delete_fe_invoice_payments.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeFeInvoicePaymentDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveFeInvoicePayments">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_fe_invoice_payments"
                :heading="$t('lang.delete_fe_invoice_payment')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteFeInvoicePayments(fe_invoice_payment.payment_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openFeInvoicePaymentForm" },
                { title: this.$t("lang.refresh"), action: "dbGetFeInvoicePayments", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.payment_id"), sortable: false, width: "9%" },
                { text: this.$t("lang.invoice_id"), sortable: false, width: "9%" },
                { text: this.$t("lang.company"), sortable: false, width: "9%" },
                { text: this.$t("lang.amount"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_term"), sortable: false, width: "9%" },
                { text: this.$t("lang.payment_date"), sortable: false, width: "9%" },
                { text: this.$t("lang.due_date"), sortable: false, width: "9%" },
                { text: this.$t("lang.bank_account"), sortable: false, width: "9%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            fe_invoice_payment: {
                payment_date: new Date().toISOString().substr(0, 10),
                due_date: new Date().toISOString().substr(0, 10),
                currency_id: "1",
                exchange_rate: "1.000",
                account_id: "1",
                payment_term_id: "1",
                amount: "0.000",
                notes: null,
            },
            filter: {
                search: "",
                status: "1",
            },
            fe_invoice_payment_dialog: false,
            dbGetFeInvoicePayments: _.debounce(this.getFeInvoicePayments, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchFeInvoicePayments", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.fe_invoice_payments) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchFeInvoicePayments({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.fe_invoice_payments) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                this.refresh();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.fe_invoice_payments.fe_invoice_payments_filter,
            page: (state) => state.fe_invoice_payments.page,
            rules_fe_invoice_payments: (state) => state.fe_invoice_payments.rules_fe_invoice_payments,
            fe_invoice_payment_status_options: (state) => state.settings.fe_invoice_payment_status_options,
            fe_invoice_payments: (state) => state.fe_invoice_payments.fe_invoice_payments,
            fe_invoices: (state) => state.fe_invoices.fe_invoices,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            currencies: (state) => state.currencies.currencies,
            bank_accounts: (state) => state.bank_accounts.bank_accounts,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions([
            "fetchFeInvoicePayments",
            "saveFeInvoicePayment",
            "deleteFeInvoicePayment",
            "fetchPaymentTerms",
            "fetchCurrencies",
            "fetchOptions",
            "fetchBankAccounts",
            "fetchFeInvoices",
            "fetchFeInvoices",
            "fetchCustomers",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openFeInvoicePaymentForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_fe_invoice_payment)
                        item ? this.$refs.form_fe_invoice_payment.resetValidation() : this.$refs.form_fe_invoice_payment.reset();

                    this.$nextTick(() => {
                        this.fe_invoice_payment = item != null ? this.assignObj2(item, this.rules_fe_invoice_payments) : {};
                        this.fe_invoice_payment_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "fe_invoice_payment", params: { id: item.payment_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_fe_invoice_payment)
                        item ? this.$refs.form_fe_invoice_payment.resetValidation() : this.$refs.form_fe_invoice_payment.reset();
                    this.fe_invoice_payment_dialog = true;
                } else {
                    this.$router.push({ name: "fe_invoice_payment" });
                }
            }
        },
        saveFeInvoicePayments() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_fe_invoice_payment")) {
                    let body = this.prepForm(this.fe_invoice_payment, this.rules_fe_invoice_payments);

                    this.saveFeInvoicePayment({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getFeInvoicePayments();
                                this.closeFeInvoicePaymentDialog();
                            } else {
                                this.$router.push({ name: "fe_invoice_payment", params: { id: data.payment_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteFeInvoicePayments(id = null) {
            this.deleteFeInvoicePayment({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getFeInvoicePayments();
                    this.closeFeInvoicePaymentDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeFeInvoicePaymentDialog() {
            this.fe_invoice_payment_dialog = false;
            this.$refs.delete_fe_invoice_payments.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getFeInvoicePayments(pg_refresh = false) {
            this.startLoader();

            this.fetchFeInvoicePayments({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.fe_invoice_payment_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        setupFeInvoicePaymentAmount(invoice_id) {
            let invoice = this.fe_invoices.find((item) => item.invoice_id == invoice_id);
            if (invoice) {
                this.fe_invoice_payment.amount = invoice.balance;
            }
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.fe_invoices.length == 0 || force == true) await this.fetchFeInvoices({ body: { options: 1, status: "open" } });
            if (this.currencies.length == 0 || force == true) await this.fetchCurrencies({ body: { options: 1 } });
            if (this.payment_terms.length == 0 || force == true) await this.fetchPaymentTerms({ body: { options: 1 } });
            if (this.bank_accounts.length == 0 || force == true) await this.fetchBankAccounts({ body: { options: 1 } });

            this.finishLoader();
        },
    },
};
</script>
